export function sortAdapter(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { date: -1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    date: 'date',
    coach: 'coach.name',
    coachee: 'coachee.name',
    status: 'status',
    sessionNumber: 'sessionNumber',
  };

  const dbField = fieldMap[field] || 'date';

  return { [dbField]: order };
}

export function sortAdapterCoachees(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { activeUser: -1, createdAt: -1, name: 1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    name: 'name',
    createdAt: 'createdAt',
    coach: 'coach.name',
    company: 'company.name',
    status: 'statusUser',
    sessionNumber: 'sessionNumber',
    activeUser: 'activeUser',
  };

  const dbField = fieldMap[field] || 'createdAt';
  const sort: Record<string, 1 | -1> = {};
  if (dbField === 'createdAt') {
    sort.activeUser = -1;
  }
  sort[dbField] = order as 1 | -1;
  if (dbField !== 'name') {
    sort.name = 1;
  }
  return sort;
}

export function sortAdapterCoaches(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { statusUser: -1, name: 1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    name: 'name',
    createdAt: 'createdAt',
    coach: 'coach.name',
    company: 'company.name',
    status: 'statusUser',
    sessionNumber: 'sessionNumber',
  };

  const dbField = fieldMap[field] || 'name';
  const sort: Record<string, 1 | -1> = {
    [dbField]: order as 1 | -1,
  };
  if (dbField !== 'name') {
    sort.name = 1;
  }
  return sort;
}

export function sortAdapterFocusAreas(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { focusArea: 1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    focusArea: 'focusArea',
    statusArea: 'statusArea',
  };

  const dbField = fieldMap[field] || 'focusArea';
  const sort: Record<string, 1 | -1> = {};
  if (dbField !== 'statusArea') {
    sort.statusArea = -1;
  }
  sort[dbField] = order as 1 | -1;
  if (dbField !== 'focusArea') {
    sort.focusArea = 1;
  }
  return sort;
}

export function sortAdapterResources(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { name: 1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    name: 'name',
    createdAt: 'createdAt',
  };

  const dbField = fieldMap[field] || 'name';
  return { [dbField]: order as 1 | -1 };
}

export function sortAdapterPrograms(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { createdAt: -1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    name: 'name',
    createdAt: 'createdAt',
    status: 'status',
  };

  const dbField = fieldMap[field] || 'createdAt';
  return { [dbField]: order as 1 | -1 };
}

export function sortAdapterMentoringPrograms(
  sortValue: string | undefined,
): Record<string, 1 | -1> {
  if (!sortValue) return { createdAt: -1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    name: 'name',
    createdAt: 'createdAt',
    status: 'status',
  };

  const dbField = fieldMap[field] || 'createdAt';
  return { [dbField]: order as 1 | -1 };
}

export function sortAdapterCohorts(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { StartDate: -1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    name: 'Name',
    StartDate: 'StartDate',
    program: 'Program',
    company: 'Company.name',
    endProgramDate: 'endProgramDate',
  };

  const dbField = fieldMap[field] || 'StartDate';
  return { [dbField]: order as 1 | -1 };
}

export function sortAdapterCompanies(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { createdAt: -1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    name: 'name',
    contact: 'contact',
    email: 'email',
    phone: 'phone',
    country: 'country',
    createdAt: 'createdAt',
  };

  const dbField = fieldMap[field] || 'createdAt';
  return { [dbField]: order as 1 | -1 };
}

export function sortAdapterAdmin(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { Name: 1 }; // Orden alfabético por defecto
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    name: 'Name',
    email: 'Email',
    role: 'Role',
  };

  const dbField = fieldMap[field] || 'Name';
  return { [dbField]: order as 1 | -1 };
}

export function sortAdapterQuestions(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { question: 1 }; // Orden alfabético por defecto
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    question: 'question',
    focusArea: 'focusArea.focusArea',
    status: 'status',
    createdAt: 'createdAt',
  };

  const dbField = fieldMap[field] || 'question';
  return { [dbField]: order as 1 | -1 };
}

export function sortAdapterMidNps(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { createdAt: -1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    coacheeName: 'coacheeUser.name',
    companyName: 'companyDoc.name',
    recomendation: 'recomendation',
    createdAt: 'createdAt',
  };

  const dbField = fieldMap[field] || 'createdAt';
  return { [dbField]: order as 1 | -1 };
}

export function sortAdapterFinalNps(sortValue: string | undefined): Record<string, 1 | -1> {
  if (!sortValue) return { createdAt: -1 };
  const [field, direction] = sortValue.split('-');
  const order = direction === 'asc' ? 1 : -1;

  const fieldMap: Record<string, string> = {
    coacheeName: 'coacheeUser.name',
    companyName: 'companyDoc.name',
    recomendation: 'recomendation',
    resume: 'resume',
    createdAt: 'createdAt',
  };

  const dbField = fieldMap[field] || 'createdAt';
  return { [dbField]: order as 1 | -1 };
}
